import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/report-management/best-selling-items-report`;

export const bestSellingItemsReportRoutesObj = {
  list: baseRoute,
  view: `${baseRoute}/view/:productId`,
} as const;

export type IBestSellingItemsReportRouteParams = IExtractRouteParamMap<
  typeof bestSellingItemsReportRoutesObj
>;

export const bestSellingItemsReportPath = createPaths<
  typeof bestSellingItemsReportRoutesObj,
  IBestSellingItemsReportRouteParams
>(bestSellingItemsReportRoutesObj);
